import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const CancelledOrderViewPage = withCompass(
  () => import("../../pages/CancelledOrderViewPage")
);

export function GabrielaTeranRoutes() {
  return (
    <Switch>
      <Route
        path="/gt/cancelled-order-view"
        component={CancelledOrderViewPage}
      />
    </Switch>
  );
}

export const slug = "gt";
